// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/list/list-item/list-item-text/list-item-text.less
// module id = 3231
// module chunks = 0